import { render } from "./WaitForStart.vue?vue&type=template&id=61f8f713&scoped=true"
const script = {}

import "./WaitForStart.vue?vue&type=style&index=0&id=61f8f713&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61f8f713"

export default script